import axios from '@/libs/api.request'

// 权限列表
export const apiPermissionList = data => {
  return axios.request({
    url: '/agency/permission',
    method: 'get',
    data
  })
}
// 上级菜单
export const apiPartnerMenu = data => {
  return axios.request({
    url: '/agency/permission-menu',
    method: 'get',
    data
  })
}
// 权限详情
export const apiPermissionDetail = (id, data) => {
  return axios.request({
    url: `/agency/permission/${id}`,
    method: 'get',
    data
  })
}
// 添加权限
export const apiPermissionAdd = data => {
  return axios.request({
    url: '/agency/permission',
    method: 'post',
    data
  })
}
// 修改权限
export const apiPermissionUpdate = (id, data) => {
  return axios.request({
    url: `/agency/permission/${id}`,
    method: 'put',
    data
  })
}
// 删除权限
export const apiPermissionDelete = (id, data) => {
  return axios.request({
    url: `/agency/permission/${id}`,
    method: 'delete',
    data
  })
}

// 获取权限列表
export const apiPermissionMenu = (data) => {
  return axios.request({
    url: `/agency/permission-menu`,
    method: 'get',
    data
  })
}
// 企业授权
export const apiPermissionCompany = (data) => {
  return axios.request({
    url: `/company-empower`,
    method: 'post',
    data
  })
}